import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { useCloud } from './useCloud'
import type { CloudMarketplace } from '../../types/marketplace'

/** Matches marketplace productListingFilter `ProductListingFilterType.SET_CLOUD_MARKETPLACE`. */
export const SET_CLOUD_MARKETPLACE = 'SET_CLOUD_MARKETPLACE'

export const setCloudMarketplaceProductListing = (cloud: CloudMarketplace) => ({
  type: SET_CLOUD_MARKETPLACE,
  payload: cloud,
})

/**
 * Syncs the product listing filter cloud marketplace with the cloud from useCloud.
 * This ensures Redux state matches the actual cloud based on account selection.
 */
export const useSyncCloudMarketplace = () => {
  const dispatch = useDispatch()
  const cloudFromUseCloud = useCloud({ product: 'flyout' })

  useEffect(() => {
    if (cloudFromUseCloud) {
      dispatch(setCloudMarketplaceProductListing(cloudFromUseCloud))
    }
  }, [cloudFromUseCloud, dispatch])
}
